export default __webpack_public_path__ + "static/media/EG_Snappy-3.603d289d.wav";